import { createContext, ReactNode, useContext, useState } from "react";

/**
 * Sentinel the "Show all photos" buttons hand to setFullScreenImageIndex:
 * open the browser at the top instead of scrolled to a photo (#1694). The
 * toolkit opens its grid at the top too, and in the photo tour the index of
 * room tiles sits above the first photo and is what the guest must land on.
 */
export const OPEN_AT_TOP = -1

interface GalleryContextValue {
    fullScreenImageIndex: number | undefined
    setFullScreenImageIndex: (index: number | undefined) => void
    lightBoxImageIndex: number | undefined
    setLightBoxImageIndex: (index: number | undefined) => void
}

const GalleryContext = createContext<GalleryContextValue | undefined>(undefined);

export function GalleryProvider({ 
    children, 
  }: { 
    children: ReactNode;
  }) {
  const [fullScreenImageIndex, setFullScreenImageIndex] = useState<number>()
  const [lightBoxImageIndex, setLightBoxImageIndex] = useState<number>()
  
  return (
    <GalleryContext.Provider value={{ fullScreenImageIndex, setFullScreenImageIndex, lightBoxImageIndex, setLightBoxImageIndex }}>
      {children}
    </GalleryContext.Provider>
  )
}

export function useGallery() {
    const context = useContext<GalleryContextValue | undefined>(GalleryContext);
    if (!context) {
        throw new Error('useGallery must be used within a GalleryProvider');
    }
    return context;
}
